module.exports = __webpack_public_path__ + "static/img/cannon.13e7d8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/cannon.jpg
// module id = 8nlo
// module chunks = 1